import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as $8rdZD$useState, useRef as $8rdZD$useRef } from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $b45bbbaf0c3785df$export$29efd034f1d79f81(props) {
  var _getItems = props.getItems,
      isDisabled = props.isDisabled,
      collection = props.collection,
      selectionManager = props.selectionManager,
      onDragStart = props.onDragStart,
      onDragMove = props.onDragMove,
      onDragEnd = props.onDragEnd,
      preview = props.preview,
      getAllowedDropOperations = props.getAllowedDropOperations;

  var _ref = (0, $8rdZD$useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      setDragging = _ref2[1];

  var draggingKeys = (0, $8rdZD$useRef)(new Set());
  var draggedKey = (0, $8rdZD$useRef)(null);

  var getKeys = function getKeys(key) {
    // The clicked item is always added to the drag. If it is selected, then all of the
    // other selected items are also dragged. If it is not selected, the only the clicked
    // item is dragged. This matches native macOS behavior.
    var keys = new Set(selectionManager.isSelected(key) ? new Set(_toConsumableArray(selectionManager.selectedKeys).filter(function (key) {
      return !!collection.getItem(key);
    })) : []);
    keys.add(key);
    return keys;
  };

  return {
    collection: collection,
    selectionManager: selectionManager,

    get draggedKey() {
      return draggedKey.current;
    },

    get draggingKeys() {
      return draggingKeys.current;
    },

    isDragging: function isDragging(key) {
      return draggingKeys.current.has(key);
    },
    getKeysForDrag: getKeys,
    getItems: function getItems(key) {
      return _getItems(getKeys(key));
    },
    isDisabled: isDisabled,
    preview: preview,
    getAllowedDropOperations: getAllowedDropOperations,
    startDrag: function startDrag(key, event) {
      var keys = getKeys(key);
      draggingKeys.current = keys;
      draggedKey.current = key;
      selectionManager.setFocused(false);
      setDragging(true);
      if (typeof onDragStart === 'function') onDragStart(_objectSpread(_objectSpread({}, event), {}, {
        keys: keys
      }));
    },
    moveDrag: function moveDrag(event) {
      if (typeof onDragMove === 'function') onDragMove(_objectSpread(_objectSpread({}, event), {}, {
        keys: draggingKeys.current
      }));
    },
    endDrag: function endDrag(event) {
      var isInternal = event.isInternal;
      if (typeof onDragEnd === 'function') onDragEnd(_objectSpread(_objectSpread({}, event), {}, {
        keys: draggingKeys.current,
        isInternal: isInternal
      }));
      draggingKeys.current = new Set();
      draggedKey.current = null;
      setDragging(false);
    }
  };
}

export { $b45bbbaf0c3785df$export$29efd034f1d79f81 as useDraggableCollectionState };